
// 연동 서버
// SMS 서버 설정
//
// @since 2021-09-09
// @author 심선우 (wj_tams_dev03)

const initSmsServerData = () => {
  return {
    log_sms_use_yn: 0,
    log_sms_sndr: '',
    log_sms_rcvr_list: '',
    log_sms_svr_port: 5000,
    log_sms_svr_id: '',
    log_sms_svr_pw: ''
  }
}
export const state = () => ({
  url: '/api/sm/external/log_sms',
  smsServerDataConfig: initSmsServerData()
})

export const mutations = {
  setSmsServerDataConfig (state, data) {
    state.smsServerDataConfig = data
    state.smsServerDataConfig.log_sms_svr_pw = ''
  }
}

export const actions = {
  async cancelSmsSettingsAction () {
    const result = await this.$axios.$put(`/api/sm/external/log_sms/cancel`, null, {cancelMsg: true, loading: true, successAlert: true})
    return result
  },
  async applySmsSettingsAction ({commit, state}) {
    const param = state.smsServerDataConfig
    const result = await this.$axios.$put('/api/sm/external/log_sms/apply', param, {applyMsg: true, loading: true, successAlert: true})
    return result
  },
  async getSmsServerData ({commit, state}) {
    const result = await this.$axios.$get(state.url)
    if (result.code === 'ok') {
      commit('setSmsServerDataConfig', result.result)
    }
    return result
  }
}
export const strict = false
